export class ReferralModel {
  organizationId: number;
  sourceCodeId: number;
  timeZoneId: number;
  timeZone: string;
  statEmployeeId: number;
  facilityEreferralCode: string;
  contactFirstName: string;
  contactLastName: string;
  contactTitleId: number;
  callbackPhoneNumber: string;
  callbackPhoneNumberExtension: string;
  cardiacDeathDateTime: Date;
  cardiacDeathDate: string;
  cardiacDeathTime: string;
  heartbeatId= -1;
  ventilatorId = -1;
  ventilatorName: string;
  referralFacility: string;
  hospitalUnitId: number;
  floor: string;
  identityUnknown: string;
  medicalRecordNumber: string;
  legalFirstName: string;
  legalLastName: string;
  admitDateTime: Date;
  admitDate: string;
  admitTime: string;
  dob: Date;
  age: number;
  ageUnitId = 0;
  ageUnitName: string;
  ageEstimated: string;
  raceId: number;
  raceName: string;
  sexId: number;
  sexName: string;
  weight: string;
  weightUnitId: number;
  weightUnitName: string;
  weightEstimated: string;
  extubationDateTime: Date;
  extubationDate: string;
  extubationTime: string;
  admittingDiagnosis: string;
  medicalHistory: string;
  aids = -1;
  hiv= -1;
  hepB = -1;
  hepC = -1;
  ivda = -1;
  recaptcha: string;
  authorizationCode: string;
}
